import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgForOf, NgIf } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { interval, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {GeneralService} from "../../../../core/services/general.service";
import {ListService} from "../../../../core/services/list.service";

@Component({
    selector: 'app-location',
    standalone: true,
    imports: [
        FormsModule,
        NgForOf,
        ReactiveFormsModule,
        NgIf
    ],
    templateUrl: './location.component.html',
    styleUrl: './location.component.scss'
})
export class LocationComponent implements OnInit, OnDestroy {
    @Input() data: any;
    @Input() confirmAction: any;

    mapUrl: SafeResourceUrl | null = null;
    latitude: number = 0;
    longitude: number = 0;

    private locationSubscription?: Subscription;
    private updateInterval = 60000; // 60 segundos

    constructor(
        public modal: NgbModal,
        private sanitizer: DomSanitizer,
        private locationService: ListService, // Necesitas crear este servicio
        private generalService: GeneralService // Tu servicio de mensajes
    ) {}

    ngOnInit() {
        this.refreshLocation();
        this.loadMap();
        this.startAutoUpdate();
    }

    ngOnDestroy() {
        // Detener la actualización automática al cerrar el modal
        if (this.locationSubscription) {
            this.locationSubscription.unsubscribe();
        }
    }

    loadMap() {
        if (this.latitude && this.longitude) {
            const url = `https://www.google.com/maps?q=${this.latitude},${this.longitude}&output=embed`;
            this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
    }

    startAutoUpdate() {
        // Actualizar cada minuto
        this.locationSubscription = interval(this.updateInterval)
            .pipe(
                switchMap(() => this.locationService.getLocation({
                    assignmentId: this.data.id // o el ID que uses
                }))
            )
            .subscribe(
                (res: any) => {
                    if (res.error) {
                        console.error('Error al actualizar ubicación:', res.message);
                    } else {
                        // Actualizar coordenadas
                        if (res.message?.location) {
                            const [lat, lng] = res.message.location.split('_').map(Number);
                            this.latitude = lat;
                            this.longitude = lng;
                            this.loadMap();
                        }
                    }
                },
                (err: any) => {
                    console.error('Error en actualización automática:', err);
                }
            );
    }

    // Método para abrir Google Maps en nueva pestaña
    openInGoogleMaps() {
        if (this.latitude && this.longitude) {
            window.open(`https://www.google.com/maps?q=${this.latitude},${this.longitude}`, '_blank');
        }
    }

    // Método para actualizar manualmente
    refreshLocation() {
        this.locationService.getLocation({
            assignmentId: this.data.id
        }).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    if (res.message?.location) {
                        const [lat, lng] = res.message.location.split('_').map(Number);
                        this.latitude = lat;
                        this.longitude = lng;
                        this.loadMap();
                        this.generalService.showMessage('success', 'Ubicación actualizada');
                    }
                }
            },
            (err: any) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        );
    }
}
